
<header class="masthead" style="background-color:#1cd5db;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto" style="font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;">
                <div class="site-heading" style="padding: 28px 0;">

                </div>
            </div>
        </div>
    </div>
</header>
<div class="container">
    <div class="row">
        <div class="col text-center">
            <h2>We sent you an reset password email</h2>
            <h5>Please check your email to reset your password</h5>
		<a class="btn btn-secondary text-white" style="border-radius:0;border:none;background-color:#1cd5db"
		[routerLink]="['']" 
		routerLinkActive="active">
		<i class="fas fa-home"></i> Go to home page</a>
        </div>
    </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
